export default function EventHandlers ()
{
  this.Type =
  {
    Long: 1,
    Short: 2
  };


  this.createHandlers = (context, args, enableLog) =>
  {
    return new Handlers(this, context, args, enableLog);
  };


  function Handlers (prThis, sender, args = {}, enableLog)
  {
    const customHandlers = [],
          type = args.type || prThis.Type.Short;

    let fired = null;


    const doFireHandlers = function(currentHandler, args)
    {
      if (BEditor.browser.isIE || currentHandler.runInTryCatch === true)
      {
        try
        {
          currentHandler(sender, args);
        }
        catch (e) {}
      }
      else
      {
        currentHandler(sender, args);
      }
    };


    this.addHandler = (handler, args = {}) =>
    {
      const handlerName = args.handlerName || null,
            period = args.period || null;

      let i;

      if (typeof (handler) !== 'function')
      {
        return;
      }

      for (i = 0; i < customHandlers.length; i++)
      {
        if (customHandlers[i].isDeleted === true)
        {
          continue;
        }

        if ((customHandlers[i].handlerName && customHandlers[i].handlerName === handlerName) || (!customHandlers[i].handlerName && customHandlers[i].handler === handler))
        {
          break;
        }
      }

      if (i >= customHandlers.length)
      {
        if (fired && !args.isNoLazyFire && period === 'once')
        {
          doFireHandlers(handler, sender, fired);
          return;
        }
        else
        {
          customHandlers.push({ handler, handlerName, period });
        }
      }

      if (fired && !args.isNoLazyFire)
      {
        doFireHandlers(handler, sender, fired);
      }
    };


    this.removeHandler = (handler, args = {}) =>
    {
      const handlerName = args.handlerName || null;

      if (customHandlers && customHandlers.length)
      {
        for (let i = 0; i < customHandlers.length; i++)
        {
          if (customHandlers[i].isDeleted)
          {
            continue;
          }

          if ((customHandlers[i].handlerName && customHandlers[i].handlerName === handlerName) || (!customHandlers[i].handlerName && customHandlers[i].handler === handler))
          {
            //var handlerToDelete = handlers.splice(i, 1);
            customHandlers[i] = { isDeleted: true };
            //handlerToDelete = null;
            break;
          }
        }
      }
    };


    this.fireHandlers = (args = {}) =>
    {
      const period = args.period || null;

      if (type === prThis.Type.Long)
      {
        fired = args;
      }

      if (customHandlers && customHandlers.length)
      {
        for (let i = 0; i < customHandlers.length; i++)
        {
          if (typeof (customHandlers[i].handler) === 'function')
          {
            let currentHandler = customHandlers[i].handler;

            if (customHandlers[i].period && customHandlers[i].period === 'once')
            {
              customHandlers[i] = { isDeleted: true };
            }

            doFireHandlers(currentHandler, args);
          }
        }
      }

      if (period === 'once')
      {
        this.disposeHandlers();
      }

      return { sender, args };
    };


    this.disposeHandlers = () =>
    {
      if (customHandlers.length !== 0)
      {
        customHandlers.splice(0, customHandlers.length);
      }

      fired = null;
    };
  }
}
